import React from 'react';

import type { ComponentWithChildren } from 'common/types/helpers';
import { BodyStrong } from 'ui/components/atoms/LegacyText';

import type { AlertMessageType } from 'hooks/useBaseAlert';
import * as Styled from './Alert.styled';

export const AlertMessage: ComponentWithChildren<AlertMessageType> = ({
  title,
  children,
  actionButton,
}) => (
  <Styled.MessageContainer>
    <BodyStrong>{title}</BodyStrong>
    {children && <Styled.MessageBody>{children}</Styled.MessageBody>}
    {actionButton && (
      <Styled.ActionButtonContainer>
        {actionButton}
      </Styled.ActionButtonContainer>
    )}
  </Styled.MessageContainer>
);

export const AlertMessageList = ({
  title,
  messages,
}: AlertMessageType & { messages: string[] }) => (
  <Styled.MessageContainer>
    <BodyStrong>{title}</BodyStrong>
    {messages?.length && (
      <Styled.MessageBody>
        <Styled.MessageList>
          {messages.map(message => (
            <li key={message}>{message}</li>
          ))}
        </Styled.MessageList>
      </Styled.MessageBody>
    )}
  </Styled.MessageContainer>
);
